import { render, staticRenderFns } from "./MSTeamsTabConfig.vue?vue&type=template&id=62dd4eb6&scoped=true"
import script from "./MSTeamsTabConfig.vue?vue&type=script&lang=js"
export * from "./MSTeamsTabConfig.vue?vue&type=script&lang=js"
import style0 from "./MSTeamsTabConfig.vue?vue&type=style&index=0&id=62dd4eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd4eb6",
  null
  
)

export default component.exports